import React, { useCallback, useMemo, useState } from "react";
import { AddCrossTinyIcon, IconButton, Menu } from "@activecollab/components";
import PropTypes from "prop-types";
import { useGoogleDriveListener } from "~/components/Google/useGoogleDriveListener";
import { AttachmentMenuList } from "../menu/index.jsx";

export const AttachmentMenuPicker = ({ target, ...rest }) => {
  const [showMenu, setShowMenu] = useState(false);
  const googlePicker = useGoogleDriveListener();

  const handleOpenMenu = useCallback(() => {
    setShowMenu(true);
  }, []);
  const handleCloseMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  const menuTarget = useMemo(() => {
    if (target) {
      return target;
    }
    return (
      <IconButton
        active={showMenu}
        variant="text colored"
        className="attachment-btn-add"
        type="button"
      >
        <AddCrossTinyIcon />
      </IconButton>
    );
  }, [showMenu, target]);

  return (
    <Menu
      open={showMenu}
      onOpen={handleOpenMenu}
      target={menuTarget}
      onClose={handleCloseMenu}
      mode="tiny"
      disableFocusLock={googlePicker}
    >
      <AttachmentMenuList
        {...rest}
        onCloseMenu={handleCloseMenu}
      />
    </Menu>
  );
};

AttachmentMenuPicker.propTypes = {
  target: PropTypes.node,
};
